import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16b8cce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mt-3 p-text-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-p-3 bg-color-secondary p-d-flex p-jc-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "ข้อมูลการชำระเงิน")
], -1))
const _hoisted_3 = { class: "p-mx-3 p-p-2" }
const _hoisted_4 = { class: "p-d-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ช่องทางการชำระเงิน", -1))
const _hoisted_6 = { class: "p-ml-auto" }
const _hoisted_7 = {
  key: 0,
  class: "p-d-flex"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "หมายเลขอ้างอิง", -1))
const _hoisted_9 = { class: "p-ml-auto" }
const _hoisted_10 = { class: "p-d-flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ธนาคารปลายทาง", -1))
const _hoisted_12 = { class: "p-ml-auto" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "หลักฐานการชำระเงิน")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.paymentName), 1)
          ])
        ]),
        (_ctx.paymentMethodId !== 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_ctx.paymentReference), 1)
              ])
            ]))
          : (_ctx.paymentMethodId == 1 && _ctx.paymentSlipDetail)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.bank)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.bank.bankName), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, " -"))
                  ])
                ]),
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentSlipDetail?.imageList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: ""
                  }, [
                    _createElementVNode("div", {
                      class: "slip-image p-my-2",
                      style: _normalizeStyle({
                'background-image': 'url(' + item?.imageUrl + ')',
              })
                    }, null, 4)
                  ]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}